import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/functions'
import 'firebase/firestore'
import 'firebase/analytics'

import firebaseConfig from '@/firebase.config.js'

firebase.initializeApp( firebaseConfig )

Vue.use(Vuex)

const state = {
  db: firebase.firestore(),
  functions: firebase.functions(),
  analytics: firebase.analytics(),
  fb: firebase,
}

const actions = {
  async addDoc({ state }, data) {
    let ref = state.db.collection( data.collection )
    let res = await ref.add( data.document )
    return res
  },
}

const mutations = {
  ADD_DOC ( state, data ) {
    console.log(data)
  },
}

const modules = {}

export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  modules: modules
})
